module.exports = __webpack_public_path__ + "img/explaur.4ff298dd.jpg";